import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIList from 'UIComponents/list/UIList';
import UIAlert from 'UIComponents/alert/UIAlert';
import { useGetDashboardUsedIn } from 'dashboard-lib/public/dashboard-used-in/useGetDashboardUsedIn';
import { UsedInList } from './UsedInList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UsedInAlert = ({
  dashboardId,
  title
}) => {
  const {
    usedInData
  } = useGetDashboardUsedIn(dashboardId);
  if (usedInData.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(UIAlert, {
    type: "danger",
    className: "m-top-2",
    children: [title, /*#__PURE__*/_jsx(UsedInList, {
      usedInData: usedInData
    })]
  });
};
export const DashboardUsedInAlertList = ({
  dashboards
}) => {
  if (dashboards.length === 0) {
    return;
  }
  return /*#__PURE__*/_jsxs(UIList, {
    className: "m-top-2",
    children: [dashboards.length === 1 && /*#__PURE__*/_jsx(UsedInAlert, {
      dashboardId: dashboards[0].id,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.dashboardUsedIn.singleDashboardUsedIn"
      })
    }), dashboards.length > 1 && dashboards.map(dashboard => /*#__PURE__*/_jsx(UsedInAlert, {
      dashboardId: dashboard.id,
      title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "reporting-action-components.dashboardUsedIn.bulkDashboardUsedIn",
        options: {
          dashboardName: dashboard.name
        }
      })
    }, dashboard.id))]
  });
};